<div
    id="dashboard"
    class="container-fluid"
    screenAnalytics="dashboard"
    *ngIf="currentOrganisation"
>
    <div class="row" *ngIf="showingWidgets$ | async as showingWidgets">
        <div
            class="col-xs-12 col-lg-12"
            *ngFor="let widget of showingWidgets"
            @fadeInExpandOnEnter
            @fadeOutCollapseOnLeave
        >
            <ng-container [widget]="widget"></ng-container>
        </div>
    </div>
</div>
<!-- Required to show dialogues -->
<router-outlet></router-outlet>
